module.exports = __webpack_public_path__ + "img/back-logo.c30031ae.png";